import { render, staticRenderFns } from "./sku-form.vue?vue&type=template&id=68970277&scoped=true"
import script from "./sku-form.vue?vue&type=script&lang=js"
export * from "./sku-form.vue?vue&type=script&lang=js"
import style0 from "./sku-form.vue?vue&type=style&index=0&id=68970277&prod&lang=scss&scoped=true"
import style1 from "./sku-form.vue?vue&type=style&index=1&id=68970277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68970277",
  null
  
)

export default component.exports